/**
 * 大整数安全的JSON序列化/反序列化工具
 * 解决JavaScript Number类型精度丢失问题（超过Number.MAX_SAFE_INTEGER的大整数）
 */

/**
 * 检查是否为可能丢失精度的大整数
 */
function isLargeNumber(value) {
  if (typeof value === 'number' && !isNaN(value)) {
    return value > Number.MAX_SAFE_INTEGER || value < Number.MIN_SAFE_INTEGER
  }
  if (typeof value === 'string') {
    // 尝试转换为数字，检查是否会丢失精度
    const num = Number(value)
    if (!isNaN(num) && String(num) !== value) {
      return true
    }
    // 检查是否是纯数字字符串且长度超过安全范围
    if (/^-?\d+$/.test(value) && value.length > 15) {
      return true
    }
  }
  return false
}

/**
 * 安全的JSON序列化（将大整数转换为字符串）
 * @param {Object} obj - 要序列化的对象
 * @returns {String} JSON字符串
 */
export function stringifySafe(obj) {
  return JSON.stringify(obj, (key, value) => {
    // 如果是大整数，转换为字符串
    if (isLargeNumber(value)) {
      return String(value)
    }
    // 如果值看起来像大整数（可能是字符串形式的大整数）
    if (typeof value === 'string' && /^-?\d{16,}$/.test(value)) {
      return value // 保持为字符串
    }
    return value
  })
}

/**
 * 安全的JSON解析（保持大整数为字符串）
 * @param {String} jsonStr - JSON字符串
 * @returns {Object} 解析后的对象
 */
export function parseSafe(jsonStr) {
  if (!jsonStr || typeof jsonStr !== 'string') {
    return jsonStr
  }

  try {
    return JSON.parse(jsonStr, (key, value) => {
      // 如果值是大整数字符串，保持为字符串
      if (typeof value === 'string' && /^-?\d{16,}$/.test(value)) {
        return value
      }
      // 如果值是数字且可能丢失精度，转换为字符串
      if (typeof value === 'number' && isLargeNumber(value)) {
        return String(value)
      }
      return value
    })
  } catch (e) {
    console.error('JSON解析失败:', e, 'JSON字符串:', jsonStr)
    throw e
  }
}

/**
 * 递归处理对象中的大整数（转换为字符串）
 * @param {*} obj - 要处理的对象
 * @returns {*} 处理后的对象
 */
export function convertBigIntToString(obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (typeof obj === 'number' && isLargeNumber(obj)) {
    return String(obj)
  }

  if (typeof obj === 'string' && /^-?\d{16,}$/.test(obj)) {
    return obj // 已经是字符串形式的大整数，保持不变
  }

  if (Array.isArray(obj)) {
    return obj.map(item => convertBigIntToString(item))
  }

  if (typeof obj === 'object') {
    const result = {}
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = convertBigIntToString(obj[key])
      }
    }
    return result
  }

  return obj
}

export default {
  stringifySafe,
  parseSafe,
  convertBigIntToString
}
